export const mapBook = new Map([
  [
    "pat-techno",
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/books/del/pat-techo-del.pdf",
  ],
  [
    "pat-synthese",
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/books/del/pat-synthese-del-2.pdf",
  ],
  [
    "pat-synthese-corrected",
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/books/del/pat-synthese-corrected-del.pdf",
  ],
  [
    "boul-sciencesappliquees",
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/books/del/boul-sciencesappliquees-del.pdf",
  ],
  ["boul-gestionsappliquees", ""],
  [
    "boul-techno",
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/books/del/boul-techno-del.pdf",
  ],
  [
    "boul-synthese",
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/books/del/del-boul-synthese.pdf",
  ],
  [
    "boul-synthese-corrected",
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/books/del/boul-synthese-del.pdf",
  ],
  [
    "pat-pse",
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/books/del/pat-pse-del.pdf",
  ],
  [
    "boul-pse",
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/books/del/boul-pse-del.pdf",
  ],
  [
    "char-pse",
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/books/del/char-pse-del.pdf",
  ],
  [
    "char-annee1",
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/books/del/char-annee1-del.pdf",
  ],
  [
    "char-annee2",
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/books/del/char-annee2-del.pdf",
  ],
  [
    "char-sciencesappliquees",
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/books/del/char-sciencesappliquees-del.pdf",
  ],
  [
    "prim-techno",
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/books/del/prim-techno.pdf",
  ],
]);

export const getFileUrl = (url?: string, filePath?: string) => {
  const file = mapBook.get(filePath ?? "");
  if (url !== undefined && url.length > 0) return url;
  if (filePath !== undefined && file !== undefined) return file;
  return "";
};

export const getTechno = (techno: string) => {
  switch (techno) {
    case "boul":
      return "boulangerie";
    case "pat":
      return "pâtisserie";
    case "char":
      return "charcuterie";
    case "prim":
      return "primeur";
    default:
      return "--techno--";
  }
};

export const getType = (type: string) => {
  switch (type) {
    case "sciencesappliquees":
      return "Sciences Appliquées";
    case "gestionsappliquees":
      return "Gestion Appliquée";
    case "techno":
      return "Technologie";
    case "annee1":
      return "Livre de Technologie - Première Année";
    case "annee2":
      return "Livre de Technologie - Deuxième Année";
    case "pse":
      return "Prévention Santé Environnement (PSE)";
    case "synthese":
      return "synthèse";
    case "synthese-corrected":
      return "synthèse corrigé";

    default:
      return "--type--";
  }
};
